import { setTimeout, $contentArea } from 'utils/wrappers';

export function flash(message, klass, noClose) {
  const contentArea = $contentArea();
  let flashContainer = contentArea.find('.flash-container');

  if (!flashContainer.length) {
    contentArea.prepend("<div class='flash-container'></div>");
    flashContainer = contentArea.find('.flash-container');
  }

  const alertHtml = $(`${'' +
    '<div class="alert '}${klass}">` +
    '<button class="button close" data-dismiss="alert">×</button>' +
    `<div class="content text-center">${message}</div>` +
    '</div>');

  flashContainer.append(alertHtml);

  if (!noClose) {
    setTimeout(() => {
      alertHtml.fadeOut(400, () => {
        alertHtml.remove();
        if (!flashContainer.children().length) {
          flashContainer.remove();
        }
      });
    }, 8000);
  }
}

export function getResponseText(response) {
  return JSON.parse(response.responseText);
}

export function parseResponseError(response) {
  const responseObject = getResponseText(response);

  if (responseObject.error && responseObject.error.message) {
    return responseObject.error.message;
  } else if (responseObject.message) {
    return responseObject.message;
  } else {
    return responseObject.code;
  }
}

export function getResponseErrors(response) {
  return getResponseText(response).error.errors;
}

export function showError(message, noClose) {
  flash(message, 'alert-danger', noClose);
}

export function showResponseError(response) {
  showError(parseResponseError(response));
}

export function showSuccess(message) {
  flash(message, 'alert-success');
}

export function hideFlash() {
  $contentArea().find('.flash-container').html('');
}



// WEBPACK FOOTER //
// ./utils/messages.js